<template>
  <div class="form-template-container" ref="editor">
    <div class="dragable-container">
      <!-- <select class="form-control" @select="AddField">
        <option value="">בחר שדה</option>
        <option
          v-for="(option, idx) in fieldOptions"
          :key="idx"
          :value="option.Value"
        >
          {{ option.Text }}hheight
        </option>
      </select> -->
      <div class="buttons-container">
        <!-- <div>
          <button v-for="(option, idx) in fieldOptions" :key="idx" @click="AddField(idx)" style="width: 170px">
            <span>
              {{ option.Text }}
            </span>
            <font-awesome-icon icon="fa-solid fa-file-signature" />
          </button>
        </div> -->
        <button @click="saveTemplate" :disabled="fields.length < 1 || inProgress"
          :class="fields.length < 1 || inProgress ? 'disabled' : ''" style="width: 85px">
          <span v-if="!inProgress">
            <span v-if="isUpdate">עדכן </span>
            <span v-if="!isUpdate">שמור </span>
            <font-awesome-icon icon="fa-solid fa-floppy-disk" />
          </span>
          <span v-if="inProgress">
            שומר...
          </span>
        </button>
      </div>
    </div>
    <div v-if="images.length < 1">
      <div class="spinner">
        <div class="double-bounce1"></div>
        <div class="double-bounce2"></div>
      </div>
    </div>
    <div class="right-side" v-if="!getInProgress">
              <!-- Buttons Table -->
        <h2 class="properties-header">הוספת שדות:</h2>
        <div class="buttons-table">
          <div class="buttons-table-grid">
            <!-- Dynamic rows based on fieldOptions -->
            <div 
              v-for="(option, idx) in fieldOptions" 
              :key="`option-${idx}`"
            >
              <div 
                v-for="(button, index) in option.Buttons" 
                :key="`button-${idx}-${index}`"
                class="buttons-table-row clickable-row"
                :data-assignee="button.assigneeNumber"
                @click="AddField(idx, index)"
              >
                <div class="buttons-table-name">
                  {{ button.Text }} 
                  <span style="font-size: 11px; margin-right: 8px;">
                    ({{ option.Title }})
                  </span>
                </div>
                <div class="buttons-table-icon">
                  <font-awesome-icon 
                    :icon="getFieldIcon(button.Value)" 
                  />
                </div>
                <div class="buttons-table-value">
                  <div :class="`circle-icon assignee-${button.assigneeNumber}`"></div>
                </div>
              </div>
              
              <!-- Add separator after each group (except the last one) -->
              <div 
                v-if="idx < fieldOptions.length - 1" 
                class="buttons-table-separator"
              ></div>
            </div>
            
            <!-- Separator between fieldOptions and general fields -->
            <div class="buttons-table-separator"></div>
            
            <!-- Representer buttons (assignee 99) - only show for admins and if current assignee is not 99 -->
            <template v-if="isSpecialAttributesAllowed && queryAssigneeNumber !== 99">
              <div 
                v-for="(button, index) in [{ Value: 'signature', Text: 'חתימה', assigneeNumber: 99 }, { Value: 'signatureDate', Text: 'תאריך חתימה', assigneeNumber: 99 }, { Value: 'assigneeName', Text: 'שם החותם/ת', assigneeNumber: 99 }]" 
                :key="`representer-${index}`"
                class="buttons-table-row clickable-row"
                :data-assignee="button.assigneeNumber"
                @click="AddField(0, index, button)"
              >
                <div class="buttons-table-name">
                  {{ button.Text }} 
                  <span style="font-size: 11px; margin-right: 8px;">
                    (חתימת מייצג)
                  </span>
                </div>
                <div class="buttons-table-icon">
                  <font-awesome-icon 
                    :icon="getFieldIcon(button.Value)" 
                  />
                </div>
                <div class="buttons-table-value">
                  <div :class="`circle-icon assignee-${button.assigneeNumber}`"></div>
                </div>
              </div>
              
              <!-- Separator between representer and special fields -->
              <div class="buttons-table-separator"></div>
            </template>
            
            <!-- Special fields - available to all users -->
            <!-- Label Field -->
            <div 
              class="buttons-table-row clickable-row"
              data-assignee="label"
              @click="AddClientDetailsField"
            >
              <div class="buttons-table-name">תווית</div>
              <div class="buttons-table-icon">
                <font-awesome-icon :icon="getFieldIcon('label')" />
              </div>
              <div class="buttons-table-value"><div class="circle-icon label"></div></div>
            </div>
            
            <!-- textbox Field -->
            <div 
              class="buttons-table-row clickable-row"
              data-assignee="textbox"
              @click="AddtextboxField"
            >
              <div class="buttons-table-name">שדה טקסט</div>
              <div class="buttons-table-icon">
                <font-awesome-icon :icon="getFieldIcon('textbox')" />
              </div>
              <div class="buttons-table-value"><div class="circle-icon textbox"></div></div>
            </div>
            
            <!-- checkbox Field -->
            <div 
              class="buttons-table-row clickable-row"
              data-assignee="checkbox"
              @click="AddcheckboxField"
            >
              <div class="buttons-table-name"> תיבת סימון (צ'קבוקס)</div>
              <div class="buttons-table-icon">
                <font-awesome-icon :icon="getFieldIcon('checkbox')" />
              </div>
              <div class="buttons-table-value"><div class="circle-icon checkbox"></div></div>
            </div>
          </div>
        </div>
        <h2 v-if="currField" class="properties-header">מאפייני שדה:</h2>
        <div v-if="currField" class="details">
           <div class="properties-grid">
             <!-- Field Type -->
             <div class="property-row">
                            <div class="property-name">סוג שדה</div>
             <div class="property-value">{{ (currField.type === 'label' || currField.type === 'textbox' || currField.type === 'checkbox') ? getFieldTypeDisplayName(currField.type) : (currField.assigneeNumber === 99 ? 'חתימת מייצג' : currField.assigneeNumber === 2 ? 'חותם 2' : 'חותם 1') + ' - ' + getFieldTypeDisplayName(currField.type) }}</div>
             </div>
             
             <!-- Linked Data - Only show for label fields -->
             <div class="property-row" v-if="currField.type === 'label'">
               <div class="property-name">נתון מקושר</div>
               <div class="property-value">
                 <div v-if="!selectOptions || selectOptions.length === 0" class="no-options-message">
                   <span>טוען אפשרויות...</span>
                 </div>
                 <BDropdown
                   v-else
                   v-model="currField.bindingId"
                   @change="onBindingChange"
                   class="buefy-dropdown"
                   expanded
                   aria-role="list"
                   :mobile-modal="false"
                   :overlay="false"
                   v-model:active="isBindingDropdownOpen"
                 >
                   <template #trigger>
                     <button class="dropdown-trigger binding-trigger" :class="{ 'active': isBindingDropdownOpen }" @click="isBindingDropdownOpen = !isBindingDropdownOpen">
                       <span>{{ getBindingDisplayName(currField.bindingId) || 'בחר נתון' }}</span>
                       <span class="dropdown-arrow">▼</span>
                     </button>
                   </template>
                   
                   <div class="search-container">
                     <BInput
                       v-model="bindingSearchQuery"
                       placeholder="חיפוש..."
                       icon="magnify"
                       size="is-small"
                       class="search-input"
                     />
                     
                     <!-- Loading indicator -->
                     <div v-if="isLoadingDropdowns" class="loading-indicator">
                       <span>טוען...</span>
                     </div>
                   </div>
                   
                   <div class="dropdown-content">
                     <template v-if="filteredBindingOptions && filteredBindingOptions.length > 0">
                       <template v-for="group in filteredBindingOptions" :key="group.label">
                         <!-- Group Header -->
                         <div class="group-header">
                           <strong>{{ group.label }}</strong>
                         </div>
                         
                         <!-- Group Options -->
                         <div
                           v-for="option in group.options"
                           :key="option.value"
                           class="group-option"
                           @click.stop="onBindingSelect(option)"
                         >
                           {{ option.label }}</div>
                         
                         <!-- Separator between groups (except last group) -->
                         <div 
                           v-if="group !== filteredBindingOptions[filteredBindingOptions.length - 1]" 
                           class="group-separator"
                         >
                         </div>
                       </template>
                     </template>
                     <template v-else>
                       <div class="no-options-message">
                         <span>אין אפשרויות זמינות</span>
                       </div>
                     </template>
                   </div>
                 </BDropdown>
               </div>
             </div>
             
             <!-- Linked Data - Only show for textbox fields -->
             <div class="property-row" v-if="currField.type === 'textbox'">
               <div class="property-name">נתון מקושר</div>
               <div class="property-value">
                 <div v-if="!selectOptions || selectOptions.length === 0" class="no-options-message">
                   <span>טוען אפשרויות...</span>
                 </div>
                 <BDropdown
                   v-else
                   v-model="currField.bindingId"
                   @change="onBindingChange"
                   class="buefy-dropdown"
                   expanded
                   aria-role="list"
                   :mobile-modal="false"
                   :overlay="false"
                   v-model:active="isBindingDropdownOpen"
                 >
                   <template #trigger>
                     <button class="dropdown-trigger binding-trigger" :class="{ 'active': isBindingDropdownOpen }" @click="isBindingDropdownOpen = !isBindingDropdownOpen">
                       <span>{{ getBindingDisplayName(currField.bindingId) || 'בחר נתון' }}</span>
                       <span class="dropdown-arrow">▼</span>
                     </button>
                   </template>
                   
                   <div class="search-container">
                     <BInput
                       v-model="bindingSearchQuery"
                       placeholder="חיפוש..."
                       icon="magnify"
                       size="is-small"
                       class="search-input"
                     />
                     
                     <!-- Loading indicator -->
                     <div v-if="isLoadingDropdowns" class="loading-indicator">
                       <span>טוען...</span>
                     </div>
                   </div>
                   
                   <div class="dropdown-content">
                     <!-- Null option for unselecting binding -->
                     <div class="group-option" @click.stop="onBindingSelect({ value: null, label: 'ללא נתון מקושר' })">
                       ללא נתון מקושר
                     </div>
                     <div class="group-separator"></div>
                     
                     <template v-if="filteredBindingOptions && filteredBindingOptions.length > 0">
                       <template v-for="group in filteredBindingOptions" :key="group.label">
                         <!-- Group Header -->
                         <div class="group-header">
                           <strong>{{ group.label }}</strong>
                         </div>
                         
                         <!-- Group Options -->
                         <div
                           v-for="option in group.options"
                           :key="option.value"
                           class="group-option"
                           @click.stop="onBindingSelect(option)"
                         >
                           {{ option.label }}</div>
                         
                         <!-- Separator between groups (except last group) -->
                         <div 
                           v-if="group !== filteredBindingOptions[filteredBindingOptions.length - 1]" 
                           class="group-separator"
                         >
                         </div>
                       </template>
                     </template>
                     <template v-else>
                       <div class="no-options-message">
                         <span>אין אפשרויות זמינות</span>
                       </div>
                     </template>
                   </div>
                 </BDropdown>
               </div>
             </div>
             
             <!-- textbox Text - Only show for textbox fields -->
             <div class="property-row" v-if="currField.type === 'textbox'">
               <div class="property-name">טקסט</div>
               <div class="property-value">
                 <input 
                   type="text" 
                   v-model="currField.displayText"
                   placeholder="מלל ברירת מחדל..."
                   class="property-input textbox-text-input"
                 />
               </div>
             </div>
             
             <!-- checkbox Default Choice - Only show for checkbox fields -->
             <div class="property-row" v-if="currField.type === 'checkbox'">
               <div class="property-name">ברירת מחדל</div>
               <div class="property-value">
                 <input 
                   type="checkbox" 
                   v-model="currField.isChecked"
                   class="property-checkbox"
                 />
               </div>
             </div>
                     
                     <!-- Height -->
                     <div class="property-row">
                       <div class="property-name">גובה</div>
                       <div class="property-value">
                         <input 
                           id="height" 
                           @focus="$event.target.select()" 
                           type="text" 
                           readonly
                           v-model="currField.height"
                           class="property-input"
                         />
                       </div>
                     </div>
             
             <!-- Width -->
             <div class="property-row">
               <div class="property-name">רוחב</div>
               <div class="property-value">
                 <input 
                   id="width" 
                   @focus="$event.target.select()" 
                   type="text" 
                   readonly
                   v-model="currField.width"
                   class="property-input"
                 />
               </div>
             </div>
             
             <!-- Y Position -->
             <div class="property-row">
               <div class="property-name">רווח מלמעלה</div>
               <div class="property-value">
                 <input 
                   id="y" 
                   @focus="$event.target.select()" 
                   type="text" 
                   readonly
                   v-model="currField.y"
                   class="property-input"
                 />
               </div>
             </div>
             
             <!-- X Position -->
             <div class="property-row">
               <div class="property-name">רווח משמאל</div>
               <div class="property-value">
                 <input 
                   id="x" 
                   @focus="$event.target.select()" 
                   type="text" 
                   readonly
                   v-model="currField.x"
                   class="property-input"
                 />
               </div>
             </div>
             
             <!-- Page -->
             <div class="property-row">
               <div class="property-name">דף</div>
               <div class="property-value">
                 <input 
                   id="page" 
                   @focus="$event.target.select()" 
                   type="text" 
                   readonly
                   v-model="currField.page"
                   class="property-input"
                 />
               </div>
             </div>
           </div>
         </div>
    </div>
    <div class="all-imgs-container">
      <DraggableContainer class="all-imgs-items">
        <!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
        <div class="all-imgs-item" v-for="(image, index) in images" :key="index" :ref="`imgNumber${index + 1}`"
          style="position: relative;">
          <img :src="`data:image/jpg;base64, ${image.data}`" alt="image" />
          <!-- Past signed attributes (signatures, dates, labels, textboxes, checkboxes) -->
          <div 
            v-if="getPastSignedAttributes(index + 1)"
            v-for="(field, idx) in getPastSignedAttributes(index + 1)" 
            :key="idx" 
            :style="{
              position: 'absolute',
              left: field.x + 'px',
              top: field.y + 'px',
              width: (field.type === 'checkbox' ? 28 : (field.width || 150)) + 'px',
              height: (field.type === 'checkbox' ? 28 : (field.height || 100)) + 'px',
              zIndex: 2
            }"
            :class="[
              'past-attribute',
              field.type === 'signature' ? 'past-signature-image' : '',
              field.type === 'signatureDate' || field.type === 'assigneeName' || field.type === 'label' || field.type === 'textbox' ? 'past-text-field' : '',
              field.type === 'checkbox' ? 'past-checkbox-field' : ''
            ]"
          >
            <!-- Render signature as image -->
            <div 
              v-if="field.type === 'signature'"
              :style="{
                width: '100%',
                height: '100%',
                backgroundImage: `url(${field.value})`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundSize: 'contain',
                imageRendering: 'crisp-edges',
                imageRendering: '-webkit-optimize-contrast'
              }"
            ></div>
            
            <!-- Render text-based fields (dates, labels, assignee names, textboxes) -->
            <div 
              v-else-if="field.type === 'signatureDate' || field.type === 'assigneeName' || field.type === 'label' || field.type === 'textbox'"
              :style="{
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '14px',
                color: '#000',
                textAlign: 'center',
                padding: '2px 4px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }"
            >
              {{ field.value }}
            </div>
            
            <!-- Render checkbox -->
            <div 
              v-else-if="field.type === 'checkbox'"
              :style="{
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }"
            >
              <input 
                type="checkbox" 
                :checked="field.value === true || field.value === 'true'"
                disabled
                :style="{
                  width: '15px',
                  height: '15px',
                  cursor: 'default',
                  pointerEvents: 'none'
                }"
              />
            </div>
          </div>
        </div>
        
        <!-- All draggable signature fields at container level -->
        <Vue3DraggableResizable v-if="getSignatureFields() && images.length && showAttributes"
         :class="getBackgroundColor(field.assigneeNumber)" v-for="(field) in getSignatureFields()"
          :key="`sig-${field.id}`" :initW="field.width || 130" :initH="field.height || 85" :x="field.x" :y="getAbsoluteY(field)"
          :w="field.width" :h="field.height" :active="active" :draggable="true" :resizable="true" :parent="true"
          :lockAspectRatio="true" @resize-end="handleResizable(field.id, $event)"
          @drag-end="handleDraggable(field.id, $event)">
          <div class="draggable-resizable-field signature-field">
            <span>חתימה</span>
            <button class="remove-button" @click="removeField(field.id)">x</button>
          </div>
        </Vue3DraggableResizable>
        
        <!-- All draggable date fields at container level -->
        <Vue3DraggableResizable v-if="getDateFields() && images.length && showAttributes"
          :class="[getBackgroundColor(field.assigneeNumber), 'text-field-container']" v-for="(field) in getDateFields()"
          :key="`date-${field.id}`" :initW="field.width || 130" :initH="25" :x="field.x" :y="getAbsoluteY(field)"
          :w="field.width" :h="25" :active="active" :draggable="true" :resizable="true" :parent="true"
          :lockAspectRatio="false" @resize-end="handleResizable(field.id, $event)"
          @drag-end="handleDraggable(field.id, $event)">
          <div class="draggable-resizable-field text-field">
            <span>תאריך חתימה</span>
            <button class="remove-button" @click="removeField(field.id)">x</button>
          </div>
        </Vue3DraggableResizable>
        
        <!-- All draggable assignee name fields at container level -->
        <Vue3DraggableResizable v-if="getAssigneeNameFields() && images.length && showAttributes"
          :class="[getBackgroundColor(field.assigneeNumber), 'text-field-container']" v-for="(field) in getAssigneeNameFields()"
          :key="`assigneeName-${field.id}`" :initW="field.width || 130" :initH="25" :x="field.x" :y="getAbsoluteY(field)"
          :w="field.width" :h="25" :active="active" :draggable="true" :resizable="true" :parent="true"
          :lockAspectRatio="false" @resize-end="handleResizable(field.id, $event)"
          @drag-end="handleDraggable(field.id, $event)">
          <div class="draggable-resizable-field text-field">
            <span>שם החותם/ת</span>
            <button class="remove-button" @click="removeField(field.id)">x</button>
          </div>
        </Vue3DraggableResizable>
        
        <!-- All draggable label, textbox, and checkbox attribute fields at container level -->
        <Vue3DraggableResizable v-if="getLabelTextboxAndCheckboxAttributeFields() && images.length && showAttributes"
          :class="[getBackgroundColor(field.assigneeNumber, field.type), field.type === 'checkbox' ? 'checkbox-field-container' : 'text-field-container']" 
          :data-type="field.type"
          v-for="(field) in getLabelTextboxAndCheckboxAttributeFields()"
          :key="`${field.type}-${field.id}`" 
          :initW="field.type === 'checkbox' ? 28 : (field.width || 130)" 
          :initH="field.type === 'checkbox' ? 28 : 25" 
          :x="field.x" 
          :y="getAbsoluteY(field)"
          :w="field.type === 'checkbox' ? 28 : field.width" 
          :h="field.type === 'checkbox' ? 28 : 25" 
          :active="active" 
          :draggable="true" 
          :resizable="field.type !== 'checkbox'" 
          :parent="true"
          :lockAspectRatio="field.type === 'checkbox'" 
          @resize-end="handleResizable(field.id, $event)"
          @drag-end="handleDraggable(field.id, $event)">
          <div :class="['draggable-resizable-field', field.type === 'checkbox' ? 'checkbox-field' : 'text-field']">
            <span v-if="field.type === 'label'">{{ field.displayName || 'תווית' }}</span>
            <span v-else-if="field.type === 'textbox'">{{ getTextboxDisplayText(field) }}</span>
            <span v-else-if="field.type === 'checkbox'">
              <input 
                type="checkbox" 
                :checked="field.isChecked"
                class="field-checkbox"
                readonly
                disabled
              />
            </span>
            <button class="remove-button" @click="removeField(field.id)">x</button>
          </div>
        </Vue3DraggableResizable>
        

      </DraggableContainer>
    </div>
    <sweet-modal icon="success" ref="completed" :blocking="true" :hide-close-button="true">
      <p>
        שדות החתימה מוקמו בהצלחה!
        <br />
        <br />
        <span v-if="!isUpdate">ניתן לסגור דף זה!</span>
      </p>
    </sweet-modal>
    <sweet-modal :title="title" ref="modal" :blocking="true" :hide-close-button="true" class="opening-modal">
      <p style="font-size: 30px; margin-bottom: 30px">💬</p>
      {{ message }}
      <template #button>
        <button @click="closeModal()" class="SweetModal__Button center clickable">
          התחל
        </button>
      </template>
    </sweet-modal>
  </div>
</template>

<script>
import DocumentService from "@/services/DocumentService.js";
import Vue3DraggableResizable from "vue3-draggable-resizable";
import { SweetModal } from "sweet-modal-vue";
import { BDropdown, BInput } from "buefy";
import axios from "axios";


export default {
  name: "FormTemplate",
  data() {
    return {
      active: false,
      fieldOptions: [],
      fields: [],
      images: [],
      currField: null,
      showAttributes: false,
      pastSignedAttributes: [],
      activeAttr: null,
      activeElement: null,
      isSpecialAttributesAllowed: false,
      isSelectOpen: false,
      isUpdate: false,
      docIdInTemplate: null,
      queryAssigneeNumber: null,
      inProgress: false,
      isLoadingDropdowns: false,
      isDropdown1Open: false,
      isDropdown2Open: false,
      title: null,
      message:
         'יש לבחור את מיקום החתימה ע"י לחיצה על כפתור מיקום חתימה בחלקו הימני העליון של המסמך ולאחר מכן יש לשמור את המסמך בכפתור השמירה בחלקו השמאלי העליון של המסמך',
      selectedOption1: null,
      selectedOption2: null,
      searchQuery1: '',
      searchQuery2: '',
      bindingSearchQuery: '',
      isBindingDropdownOpen: false,
      selectOptions: [],
    };
  },
  components: {
    SweetModal,
    Vue3DraggableResizable,
    //BSelect,
    BDropdown,
    BInput,
  },
  created() {
    this.isUpdate = this.$route.name === "FormUpdateTemplate";
    this.queryAssigneeNumber = +this.$route.query.assigneeNumber;

    switch (this.queryAssigneeNumber) {
      case 1:
        this.fieldOptions = [{
          Title: 'חותם 1',
          Buttons:
            [{ Value: "signature", Text: "חתימה", assigneeNumber: 1 }, { Value: 'signatureDate', Text: 'תאריך חתימה', assigneeNumber: 1 }, { Value: 'assigneeName', Text: 'שם החותם/ת', assigneeNumber: 1 }]
        }];
        break;
      case 2:
        this.fieldOptions = [{
          Title: 'חותם 2',
          Buttons:
            [{ Value: "signature", Text: "חתימה", assigneeNumber: 2 }, { Value: 'signatureDate', Text: 'תאריך חתימה', assigneeNumber: 2 }, { Value: 'assigneeName', Text: 'שם החותם/ת', assigneeNumber: 2 }]
        }];
        break;
      case 99:
        this.fieldOptions = [{
          Title: 'חתימת מייצג',
          Buttons:
            [{ Value: "signature", Text: "חתימה", assigneeNumber: 99 }, { Value: 'signatureDate', Text: 'תאריך חתימה', assigneeNumber: 99 }, { Value: 'assigneeName', Text: 'שם החותם/ת', assigneeNumber: 99 }]
        }];
        break;

      default:
        this.fieldOptions =
          [{
            Title: 'חותם 1',
            Buttons:
              [{ Value: "signature", Text: "חתימה", assigneeNumber: 1 }, { Value: 'signatureDate', Text: 'תאריך חתימה', assigneeNumber: 1 }, { Value: 'assigneeName', Text: 'שם החותם/ת', assigneeNumber: 1 }]
          },
          {
            Title: 'חותם 2',
            Buttons:
              [{ Value: "signature", Text: "חתימה", assigneeNumber: 2 }, { Value: 'signatureDate', Text: 'תאריך חתימה', assigneeNumber: 2 }, { Value: 'assigneeName', Text: 'שם החותם/ת', assigneeNumber: 2 }]
                   }]
         break;
     }
   },
  beforeCreate() {
    axios.defaults.headers.common["x-access-token"] =
      this.$route.params.accessToken;
    this.isUpdate = this.$route.name === "FormUpdateTemplate";
    if (!this.isUpdate) {
      DocumentService.getDocument(this.$route.params.id, this.$route.query.assigneeToken).then((res) => {
        const doc = res.data;
        
        // Set document ID for dropdown options
        this.docIdInTemplate = doc.id || this.$route.params.id;
        
        this.images = doc.images;
        this.attributes = doc.attributes;
        this.pastSignedAttributes = doc.pastSignedAttributes;
        this.isSpecialAttributesAllowed = doc.isSpecialAttributesAllowed;
        
        // Fetch dropdown options now that we have the document ID
        this.fetchDropdownOptions();
        
        setTimeout(() => {
          this.showAttributes = true;
        })
        this.$refs.modal.open();
      });
    } else {
      DocumentService.getTemplate(this.$route.params.id).then((res) => {
        const tem = res.data;
        const doc = tem.document;
        this.docIdInTemplate = doc.id;
        this.images = doc.images;
        this.attributes = doc.attributes;
        this.isSpecialAttributesAllowed = tem.isSpecialAttributesAllowed;


        // Fetch dropdown options now that we have the document ID
        this.fetchDropdownOptions();

        tem.assignees[0].attributes.forEach((field, index) => {
          if (field.page > 1 && doc.images[index] && doc.images[index].size) {
            // field.y = field.y + (field.page - 1) * doc.images[index].size.height;
          }
          // delete field.page;
        });
        this.fields = tem.assignees[0].attributes;
        if (tem.assignees[1] && tem.assignees[1].attributes) {
          tem.assignees[1].attributes.forEach((a) => this.fields.push(a));
        }
        if (tem.assignees[2] && tem.assignees[2].attributes) {
          tem.assignees[2].attributes.forEach((a) => this.fields.push(a));
        }
        this.fields.forEach((f) => f.id = this.getAttrRandomId());
        
        // Populate display names for existing label attributes after fields are loaded
        this.$nextTick(() => {
          this.populateExistingLabelDisplayNames();
          // Ensure checkbox fields maintain proper dimensions
          this.ensureCheckboxDimensions();
        });
        
        setTimeout(() => {
          this.showAttributes = true;
        })
        if (!this.isUpdate) this.$refs.modal.open();
      });
    }
  },
  mounted() {
    // Component is fully mounted
  },
  computed: {
    isDocumentValid() {
      return (
        this.attributes.filter((a) => a.isValid).length ===
        this.attributes.length
      );
    },
    isSignatureField() {
      return this.currField && this.currField.type === 'signature';
    },
    isTextField() {
      return this.currField && (this.currField.type === 'signatureDate' || this.currField.type === 'assigneeName' || this.currField.type === 'label' || this.currField.type === 'textbox' || this.currField.type === 'checkbox');
    },
    fieldTypeLabel() {
       if (!this.currField) return '';
       switch (this.currField.type) {
         case 'signature':
           return 'שדה חתימה';
         case 'signatureDate':
           return 'שדה תאריך';
         case 'label':
           return 'שדה תווית';
         case 'textbox':
           return 'שדה טקסט';
         case 'checkbox':
           return 'תיבת סימון';
         default:
           return 'שדה לא ידוע';
       }
     },
     filteredOptions1() {
       if (!this.searchQuery1) return this.selectOptions;
       const query = this.searchQuery1.toLowerCase();
       return this.selectOptions.map(group => ({
         ...group,
         options: group.options.filter(option => 
           option.label.toLowerCase().includes(query) || 
           group.label.toLowerCase().includes(query)
         )
       })).filter(group => group.options.length > 0);
     },
     filteredOptions2() {
       if (!this.searchQuery2) return this.selectOptions;
       const query = this.searchQuery2.toLowerCase();
       return this.selectOptions.map(group => ({
         ...group,
         options: group.options.filter(option => 
           option.label.toLowerCase().includes(query) || 
           group.label.toLowerCase().includes(query)
         )
       })).filter(group => group.options.length > 0);
     },
     filteredBindingOptions() {
       if (!this.bindingSearchQuery) return this.selectOptions;
       const query = this.bindingSearchQuery.toLowerCase();
       return this.selectOptions.map(group => ({
         ...group,
         options: group.options.filter(option => 
           option.label.toLowerCase().includes(query) || 
           group.label.toLowerCase().includes(query)
         )
       })).filter(group => group.options.length > 0);
     },
     getInProgress() {
      return this.images.length < 1;
     }
  },
  watch: {
    'currField.width': function(newWidth) {
      if (this.currField && (this.currField.type === 'signatureDate' || this.currField.type === 'assigneeNumber' || this.currField.type === 'label' || this.currField.type === 'textbox' || this.currField.type === 'checkbox')) {
        // For checkbox fields, always maintain 28px width
        if (this.currField.type === 'checkbox') {
          this.currField.width = 28;
        } else if (newWidth < 80) {
          this.currField.width = 80;
        } else if (newWidth > 350) {
          this.currField.width = 350;
        }
      }
    },
    'currField.height': function() {
      if (this.currField && this.currField.type === 'checkbox') {
        // For checkbox fields, always maintain 28px height
        this.currField.height = 28;
      }
    },
    'currField': function(newField) {
      if (newField) {
        this.$nextTick(() => {
          this.debugDropdownState();
        });
      }
    },
    'bindingSearchQuery': function(newQuery) {
      console.log('Search query changed:', newQuery);
      this.debugSearch();
    },
    'isBindingDropdownOpen': function(newValue) {
      // Clear search query when dropdown closes
      if (!newValue) {
        this.bindingSearchQuery = '';
      }
    }
  },
  methods: {


    getBackgroundColor(assigneeNumber, fieldType = null) {
      // Special case: label, textbox, and checkbox fields from client details button should be teal
      if (assigneeNumber === 1 && (fieldType === 'label' || fieldType === 'textbox' || fieldType === 'checkbox')) return 'teal';
      if (assigneeNumber === 1) return 'ochre';
      if (assigneeNumber === 2) return 'light-gray';
      if (assigneeNumber === 99) return 'teal';
      return 'light-blue';
    },
    getFieldIcon(fieldType) {
      switch (fieldType) {
        case 'signature':
          return 'fa-solid fa-signature';
        case 'signatureDate':
          return 'fa-solid fa-calendar-days';
        case 'assigneeName':
          return 'fa-solid fa-id-badge';
        case 'label':
          return 'fa-solid fa-font';
        case 'textbox':
          return 'fa-solid fa-t';
        case 'checkbox':
          return 'fa-solid fa-square-xmark';
        default:
          return 'fa-solid fa-question';
      }
    },
    getTitleColor(title) {
      if (title === 'חותם 1') return 'title-ochre';
      if (title === 'חותם 2') return 'title-light-gray';
      if (title === 'חתימת מייצג') return 'title-light-blue';
      return '';
    },
    getUnsetField() {
      const images = [...document.querySelectorAll('.all-imgs-item')]
      const yOffset = window.pageYOffset;
      let pageIdx = 0;
      // let res = yOffset;
      let acc = 0;
      for (let i = 0; i < images.length; i++) {
        if (!yOffset) {
          pageIdx = 1;
          break;
        }
        if (acc + 0.7 * images[i].offsetHeight < yOffset) {
          acc += images[i].offsetHeight;
        } else {
          pageIdx = i + 1;
          break;
        }
        // res -= +this.images[i].size.height;
        // if (res * 0.70 >= yOffset * -1) {
        //   pageIdx = i + 2;
        //   break;
        // }
        // if (res < 0 || i === this.images.length - 1) {
        //   pageIdx = i + 1;
        //   break;
        // } 
      }
      return {
        x: 100,
        y: 300 + (yOffset - acc),
        width: 150,
        height: 50,
        page: pageIdx,
        id: this.getAttrRandomId()
      };
    },
    handleResizable(attrId, ev) {
      const idx = this.fields.findIndex((f) => f.id === attrId);
      if (idx !== -1) {
        // For checkbox fields, maintain fixed 28x28 size
        if (this.fields[idx].type === 'checkbox') {
          this.fields[idx].width = 28;
          this.fields[idx].height = 28;
        } else {
          this.fields[idx].width = ev.w;
          this.fields[idx].height = ev.h;
        }
        this.fields[idx].x = ev.x;
        this.fields[idx].y = ev.y;
      }
    },
    handleDraggable(attrId, ev) {
      let idx = this.fields.findIndex((f) => f.id === attrId);
      if (idx === -1) return;
      
      // Get actual page heights from DOM elements
      const pageElements = document.querySelectorAll('.all-imgs-item');
      if (pageElements.length === 0) return;
      
      // Calculate which page the Y position falls into using actual page heights
      let targetPage = 1;
      let pageStartY = 0;
      
      for (let i = 0; i < pageElements.length; i++) {
        const cumulativeHeight = this.getCumulativePageHeight(i + 1);
        
        if (ev.y < cumulativeHeight) {
          targetPage = i + 1;
          pageStartY = this.getCumulativePageHeight(i);
          break;
        }
        
        // If we're past all pages, place on the last page
        if (i === pageElements.length - 1) {
          targetPage = pageElements.length;
          pageStartY = this.getCumulativePageHeight(i);
        }
      }
      
      // Ensure target page is within valid range
      targetPage = Math.max(1, Math.min(targetPage, this.images.length));
      
      // Calculate Y position relative to the target page
      let relativeY = ev.y - pageStartY;
      
      // Update the field
      this.fields[idx].x = ev.x;
      this.fields[idx].y = relativeY;
      this.fields[idx].page = targetPage;
      this.fields[idx].newCurrentPage = targetPage;
      this.currField = this.fields[idx];
    },
    AddField(idx, index, button = null) {
      let currField;
      
      if (button) {
        // Use the provided button object (for representer fields)
        currField = {
          ...this.getUnsetField(),
          type: button.Value,
          assigneeNumber: button.assigneeNumber
        };
      } else {
        // Use fieldOptions (for regular assignee fields)
        currField = {
          ...this.getUnsetField(),
          type: this.fieldOptions[idx].Buttons[index].Value,
          assigneeNumber: this.fieldOptions[idx].Buttons[index].assigneeNumber
        };
      }
      
      if (currField.type === 'signature') {
        currField.width = 130;
        currField.height = 85;
      } else if (currField.type === 'signatureDate') {
        // Text fields (signatureDate)
        currField.width = 130;
        currField.height = 25;
      } else if (currField.type === 'assigneeName') {
        // Assignee name fields
        currField.width = 130;
        currField.height = 25;
      } else if (currField.type === 'label' || currField.type === 'textbox') {
        // Label and textbox attribute fields
        currField.width = 170;
        currField.height = 25;
      } else if (currField.type === 'checkbox') {
        // Checkbox attribute fields - 28x28 size
        currField.width = 28;
        currField.height = 28;
        currField.isChecked = false;
        currField.bindingId = null;
      }
      this.fields.push(currField);
      
      // Automatically focus on the newly created field
      this.currField = currField;
      
      this.isSelectOpen = false;
    },
    
    AddClientDetailsField() {
      let currField = {
        ...this.getUnsetField(),
        type: 'label',
        assigneeNumber: 1
      };
      // Label attribute fields
      currField.width = 170;
      currField.height = 25;
      
      this.fields.push(currField);
      this.currField = currField;
    },
    
         AddtextboxField() {
       let currField = {
         ...this.getUnsetField(),
         type: 'textbox',
         assigneeNumber: 1,
         bindingId: null
         // displayText will be undefined initially, showing placeholder
       };
       // textbox attribute fields
       currField.width = 170;
       currField.height = 25;
       
       this.fields.push(currField);
       this.currField = currField;
     },
     
     AddcheckboxField() {
       let currField = {
         ...this.getUnsetField(),
         type: 'checkbox',
         assigneeNumber: 1,
         isChecked: false,
         bindingId: null
       };
       // checkbox attribute fields - 28x28 size
       currField.width = 28;
       currField.height = 28;
       
       this.fields.push(currField);
       this.currField = currField;
     },
    removeField(id) {
      const idx = this.fields.findIndex(f => f.id === id);
      this.fields.splice(idx, 1);
      this.currField = null;
    },
    

    saveTemplate() {
      if (this.inProgress) return;
      this.inProgress = true;
      const arrToSend = this.fields.map((field) => {
      let heightCountBefour = 0;
      let heightCount = 0;
      let pageIdx = this.images.findIndex((_, idx) => {
      heightCountBefour = heightCount;
      heightCount += this.$refs[`imgNumber${idx + 1}`][0].clientHeight;
      return field.y < heightCount;
    });

    // const page = pageIdx >= 0 ? pageIdx + 1 : 1;
    const y = pageIdx > 0 ? field.y - heightCountBefour : field.y;
    // field.page = field.newCurrentPage || field.page;
    
    // For checkbox fields, ensure isChecked property is included
    if (field.type === 'checkbox') {
      return { 
        ...field, 
        y, 
        page: field.newCurrentPage || field.page, 
        bindingId: field.bindingId || null,
        isChecked: field.isChecked || false
      };
    }
    
    // For textbox fields, ensure displayText is included
    if (field.type === 'textbox') {
      return { 
        ...field, 
        y, 
        page: field.newCurrentPage || field.page, 
        bindingId: field.bindingId || null,
        displayText: field.displayText || ""
      };
    }
    
    // Include all field properties for other field types
    return { ...field, y, page: field.newCurrentPage || field.page, bindingId: field.bindingId || null };
  });
      
      if (!this.isUpdate) {
        const request = this.$route.query.assigneeToken ? DocumentService.updateAssigneeDocument(this.$route.params.id, this.$route.query.assigneeToken, arrToSend) : DocumentService.post(this.$route.params.id, arrToSend);
        request
          .then(() => {
            this.$refs.completed.open();
            this.onTemplateUpdate();
          })
          .catch((err) => {
            console.log("err:", err);
          })
          .finally(() => {
            this.inProgress = false;
          });
      } else {
        DocumentService.updateTemplate(
          this.docIdInTemplate,
          this.$route.params.id,
          arrToSend
        )
          .then(() => {
            this.$refs.completed.open();
            setTimeout(() => {
              this.$refs.completed.close();
            }, 1500)
            this.onTemplateUpdate();
          })
          .catch((err) => {
            console.log("err:", err);
          })
          .finally(() => {
            this.inProgress = false;
          });
      }
    },
    onAttributeClick(e, attr) {
      const element = e.target;
      this.activeAttr = attr;
      this.activeElement = element;
    },
    getAttributes(page = 1) {
      return this.fields.filter((a) => a.page === page && a.type === 'signature');
    },
    getDatesAttributes(page = 1) {
      return this.fields.filter((a) => a.page === page && a.type === 'signatureDate');
    },
    getAssigneeNameAttributes(page = 1) {
      return this.fields.filter((a) => a.page === page && a.type === 'assigneeName');
    },
    getLabelAttributes(page = 1) {
      return this.fields.filter((a) => a.page === page && a.type === 'label');
    },
    
    gettextboxAttributes(page = 1) {
      return this.fields.filter((a) => a.page === page && a.type === 'textbox');
    },
    
    getcheckboxAttributes(page = 1) {
      return this.fields.filter((a) => a.page === page && a.type === 'checkbox');
    },

    getPastSignedAttributes(page = 1) {
      if (!this.pastSignedAttributes) return [];
      return this.pastSignedAttributes.filter((a) => a.page === page);
    },
    getSignatureFields() {
      return this.fields.filter((field) => field.type === 'signature');
    },
    getDateFields() {
      return this.fields.filter((field) => field.type === 'signatureDate');
    },
    getAssigneeNameFields() {
      return this.fields.filter((field) => field.type === 'assigneeName');
    },
    
    getLabelAttributeFields() {
      return this.fields.filter((field) => field.type === 'label');
    },
    
    gettextboxAttributeFields() {
      return this.fields.filter((field) => field.type === 'textbox');
    },
    
    getcheckboxAttributeFields() {
      return this.fields.filter((field) => field.type === 'checkbox');
    },
    
    getLabelTextboxAndCheckboxAttributeFields() {
      return this.fields.filter((field) => field.type === 'label' || field.type === 'textbox' || field.type === 'checkbox');
    },

    getCumulativePageHeight(targetPageIndex) {
      // Helper function to calculate cumulative height up to a specific page
      const pageElements = document.querySelectorAll('.all-imgs-item');
      let cumulativeHeight = 0;
      
      for (let i = 0; i < Math.min(targetPageIndex, pageElements.length); i++) {
        cumulativeHeight += pageElements[i].offsetHeight;
      }
      
      return cumulativeHeight;
    },
    getAbsoluteY(field) {
      // Convert relative Y position to absolute Y position using actual page heights
      if (field.page <= 1) {
        return field.y;
      }
      
      const cumulativeHeight = this.getCumulativePageHeight(field.page - 1);
      return field.y + cumulativeHeight;
    },
    getAttrRandomId() {
      return Math.floor(Math.random() * 10000);
    },
    closeModal() {
      this.$refs.modal.close();
      const pathBetweenBackslashes = this.$route.path.split("/");
      if (pathBetweenBackslashes[1] === "template") {
        // Commented out default signature field creation
        // this.fields.push({
        //   x: 100,
        //   y: 100,
        //   width: 130,
        //   height: 85,
        //   page: 1,
        //   id: this.getAttrRandomId(),
        //   type: "signature",
        //   assigneeNumber: this.queryAssigneeNumber ? this.queryAssigneeNumber : 1
        // });
        // this.currField = this.fields[0];
      }
    },
    onTemplateUpdate() {
      window.parent.postMessage('ok', "*");
      window.parent.postMessage(this.$route.params.id, "*");
    },

        
        // Method to handle select change - spawn a field when option is selected
        onSelectChange(assigneeNumber, option) {
          // When an option is selected, spawn a field onto the document
          if (option && option.value && option.label) {
            // Create a new labelAttribute field
            let currField = {
              ...this.getUnsetField(),
              type: 'label',
              assigneeNumber: assigneeNumber,
              bindingId: option.value,
              displayName: option.label,
              width: 170,
              height: 25
            };
            
            this.fields.push(currField);
            //this.currField = currField;
          }
          
          // Reset the selection to keep the placeholder visible
          this.selectedOption1 = null;
          this.selectedOption2 = null;
          this.searchQuery1 = '';
          this.searchQuery2 = '';
        },
        


        // Fetch dropdown options from server and populate dropdowns
        async fetchDropdownOptions() {
          try {
            // Show loading state
            this.isLoadingDropdowns = true;
            
            // Get document ID from route or props
            const templateId = this.$route.params.id;
            if (!templateId) {
              console.error('No document ID available for fetching attribute bindings');
              this.isLoadingDropdowns = false;
              return;
            }
            
            // Use DocumentService to fetch attribute bindings
            const response = await DocumentService.getAttributeBindingsUserList(templateId);
            const jsonData = response.data;
            
            // Transform the JSON data to dropdown format
            const transformedOptions = this.transformJsonToDropdownOptions(jsonData);
            
            // Populate the dropdowns with the transformed data
            this.selectOptions = transformedOptions;
            
            // Now populate display names for existing label attributes
            this.populateExistingLabelDisplayNames();
            // Ensure checkbox fields maintain proper dimensions
            this.ensureCheckboxDimensions();
            
          } catch (error) {
            console.error('Error fetching dropdown options:', error);
            // You can add user notification here if needed
            // this.$toast.error('שגיאה בטעינת אפשרויות התפריט');
          } finally {
            this.isLoadingDropdowns = false;
          }
        },

        // Populate display names for existing label, textbox, and checkbox attributes using their bindingId
        populateExistingLabelDisplayNames() {
          if (!this.selectOptions || !this.fields) return;
          
          this.fields.forEach(field => {
            if ((field.type === 'label' || field.type === 'textbox' || field.type === 'checkbox') && field.bindingId) {
              const displayName = this.getDisplayNameByBindingId(field.bindingId);
              if (displayName) {
                field.displayName = displayName;
              }
            }
          });
        },
        
        // Ensure checkbox fields maintain proper dimensions
        ensureCheckboxDimensions() {
          if (!this.fields) return;
          
          this.fields.forEach(field => {
            if (field.type === 'checkbox') {
              field.width = 28;
              field.height = 28;
              if (field.isChecked === undefined) {
                field.isChecked = false;
              }
              if (field.bindingId === undefined) {
                field.bindingId = null;
              }
            }
          });
        },

        // Get display name for a field type, with enhanced label handling
        getFieldTypeDisplayName(type, bindingId = null) {
          switch (type) {
            case 'signature':
              return 'חתימה';
            case 'signatureDate':
              return 'תאריך חתימה';
            case 'assigneeName':
              return 'שם החותם/ת';
            case 'label':
              // If we have a bindingId, try to find the proper display name
              if (bindingId && this.selectOptions) {
                const displayName = this.getDisplayNameByBindingId(bindingId);
                if (displayName) {
                  return displayName;
                }
              }
              return 'תווית';
            case 'textbox':
              return 'שדה טקסט';
            case 'checkbox':
              return 'תיבת סימון';
            default:
              return 'שדה לא ידוע';
          }
        },

        // Helper method to get display name by bindingId (used by both methods)
        getDisplayNameByBindingId(bindingId) {
          if (!this.selectOptions || !bindingId) return null;
          
          for (const group of this.selectOptions) {
            const matchingOption = group.options.find(option => option.value === bindingId);
            if (matchingOption) {
              return matchingOption.label;
            }
          }
          return null;
        },

        // Get binding display name for the details table
        getBindingDisplayName(bindingId) {
          if (bindingId === null) {
            return 'ללא נתון מקושר';
          }
          return this.getDisplayNameByBindingId(bindingId);
        },

        // Get textbox display text with priority: placeholder > binding display name > default text
        getTextboxDisplayText(field) {
          if (field.type !== 'textbox') return '';
          
          // Priority 1: If displayText (placeholder) exists, show it
          if (field.displayText && field.displayText.trim() !== '') {
            return field.displayText;
          }
          
          // Priority 2: If bindingId exists and is not null, show binding display name
          if (field.bindingId) {
            const bindingDisplayName = this.getDisplayNameByBindingId(field.bindingId);
            if (bindingDisplayName) {
              return bindingDisplayName;
            }
          }
          
          // Priority 3: Default text
          return 'שדה טקסט';
        },

        // Handle binding change in details table
        onBindingChange() {
          // This method can be used for any additional logic when binding changes
        },

        // Handle binding selection in details table
        onBindingSelect(option) {
          if (this.currField && option) {
            this.currField.bindingId = option.value;
            if (option.value === null) {
              // For null selection, only allow for textbox fields
              if (this.currField.type === 'textbox') {
                this.currField.displayName = null;
              } else {
                // For label fields, don't allow null binding
                this.currField.bindingId = null;
                this.currField.displayName = null;
              }
            } else {
              this.currField.displayName = option.label;
            }
            
            // Close the dropdown after selection - try multiple approaches
            this.isBindingDropdownOpen = false;
            
            // Force close by triggering a click outside
            this.$nextTick(() => {
              // Simulate clicking outside the dropdown
              const event = new Event('click', { bubbles: true });
              document.body.dispatchEvent(event);
            });
          }
        },

        // Debug method to check dropdown state
        debugDropdownState() {
          console.log('Current field:', this.currField);
          console.log('Select options:', this.selectOptions);
          console.log('Filtered binding options:', this.filteredBindingOptions);
          console.log('Binding search query:', this.bindingSearchQuery);
          console.log('Binding dropdown open:', this.isBindingDropdownOpen);
        },

        // Toggle binding dropdown
        toggleBindingDropdown() {
          this.isBindingDropdownOpen = !this.isBindingDropdownOpen;
          console.log('Binding dropdown toggled:', this.isBindingDropdownOpen);
          
          if (this.isBindingDropdownOpen) {
            this.$nextTick(() => {
              this.debugDropdownDimensions();
            });
          }
        },

        // Debug search functionality
        debugSearch() {
          console.log('Search query:', this.bindingSearchQuery);
          console.log('Filtered options:', this.filteredBindingOptions);
          console.log('Original options:', this.selectOptions);
        },

        // Debug dropdown dimensions
        debugDropdownDimensions() {
          const dropdown = document.querySelector('.buefy-dropdown');
          const content = document.querySelector('.dropdown-content');
          const trigger = document.querySelector('.dropdown-trigger');
          
          if (dropdown) {
            console.log('Dropdown container:', {
              width: dropdown.offsetWidth,
              left: dropdown.offsetLeft,
              right: dropdown.offsetRight
            });
          }
          
          if (content) {
            console.log('Dropdown content:', {
              width: content.offsetWidth,
              left: content.offsetLeft,
              right: content.offsetRight
            });
          }
          
          if (trigger) {
            console.log('Dropdown trigger:', {
              width: trigger.offsetWidth,
              left: trigger.offsetLeft,
              right: trigger.offsetRight
            });
          }
        },

        // Transform JSON structure to dropdown options format
        transformJsonToDropdownOptions(jsonData) {
          if (!Array.isArray(jsonData)) {
            console.error('Invalid JSON data format - expected array');
            return [];
          }

          const groupedOptions = [];

          jsonData.forEach(section => {
            // Process each possible section
            const sections = [
              'generalDetails',
              'personDetails', 
              'personBankDetails',
              'spouseDetails',
              'businessDetails',
              'authoritiesDetails',
              'businessBankDetails'
            ];

            sections.forEach(sectionName => {
              if (section[sectionName] && section[sectionName].properties) {
                const sectionData = section[sectionName];
                const sectionOptions = sectionData.properties.map(prop => ({
                  label: prop.displayName,
                  value: prop.bindingId
                }));
                
                // Create grouped structure matching selectOptions format
                groupedOptions.push({
                  label: sectionData.displayName,
                  options: sectionOptions
                });
              }
            });
          });

          return groupedOptions;
        },
  },
};
</script>

<style lang="scss" scoped>
.form-template-container .dragable-container,
.form-template-container .dragable-container .buttons-container {
  width: 1093px !important;
}

.vdr-container {
  border: 1px dotted silver;
  margin: 0 auto;
  background-color: #29e;
  color: white;
  font-size: 20px;
  font-family: sans-serif;
  padding: 20px;
  touch-action: none;
  direction: rtl;
  text-align: center;
  width: 200px;
  opacity: 0.7;
  box-sizing: border-box;
  position: absolute;
  z-index: 3;

  &.active {
    outline: 3px solid #494949;
  }
}

.opening-modal {
  ::v-deep .sweet-content {
    font-size: 22px;
  }
}

.form-template-container {
  .dragable-container {
    width: 793px;
    margin: 40px auto;
    position: relative;

    .dropdown-container {
      position: absolute;
      background-color: #f1f1f1;
      min-width: 160px;
      z-index: 1;
      left: 0;

      button:hover {
        background-color: rgb(185, 185, 185);
      }
    }

         .buttons-container {
       display: flex;
       justify-content: space-between;
       flex-direction: row-reverse;
       background-color: #2e3f50;
       padding: 5px 5px;
       position: fixed;
       top: 0;
       z-index: 20;
       width: 793px;


      button {
        display: flex;
        justify-content: space-between;
        // width: 100%;
        align-items: center;
       transition: background-color 0.3s ease;
       
       &:hover {
         background-color: #7395a7;
       }
      }

      .disabled {
        cursor: no-drop;
        opacity: 0.5;
      }
    }

    button {
      // position: absolute;
      // transform: translateY(-40px);
      right: 0;
      height: 40px;
      background-color: #607d8b;
      color: white;
      padding: 7px 15px;
      font-size: 15px;
      border: none;
      cursor: pointer;
      border-radius: 4px;
    }

    .select-buttons {
      color: black;
      background-color: inherit;
      width: 100%;
      padding: 12px 16px;
      text-decoration: none;
      display: block;
    }
  }
  


  .parent {
    height: auto;
    width: 793px;
    margin: 0 auto;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    // position: absolute;
  }

  .all-imgs-container {
    width: 793px;
    margin: 0 auto;
    height: auto;
    display: inline-block;
    user-select: none;

    img {
      width: 100%;
      box-shadow: rgba(17, 17, 26, 0.1) 0px 8px 24px,
        rgba(17, 17, 26, 0.1) 0px 16px 56px, rgba(17, 17, 26, 0.1) 0px 24px 80px;
    }

    .draggable-resizable-field {
      position: relative;
      width: 100%;
      height: 100%;
      font-size: 12px;
      
      span {
        margin: 0;
      }
      
      .remove-button {
        position: absolute;
        top: 0;
        left: 0;
        transform: translate(-30px, -30px);
        font-family: cursive;
        font-style: normal;
        font-size: 12px;
        background-color: black;
        border-radius: 50%;
        padding: 2px 6px;
        line-height: 15px;
        cursor: pointer;
        z-index: 1000;
        color: white;
      }
    }

    .text-field {
      span {
        position: absolute;
        top: 50%;
        right: 5px;
        transform: translateY(-50%);
      }
      .remove-button {
        transform: translate(-12px, -16px);
      }
    }
    
    .checkbox-field-container {
      .remove-button {
        transform: translate(-10px, -12px);
      }
    }
    
    .checkbox-field {
      width: 28px !important;
      height: 28px !important;
      min-width: 28px !important;
      min-height: 28px !important;
      
      .draggable-resizable-field {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 28px !important;
        height: 28px !important;
        min-width: 28px !important;
        min-height: 28px !important;
      }
      
      span {
        position: absolute;
        top: 50%;
        right: 5px;
        transform: translateY(-50%);
        width: 15px;
        height: 15px;
        display: flex;
        align-items: center;
        justify-content: center;
        pointer-events: none;
        
        .field-checkbox {
          width: 15px !important;
          height: 15px !important;
          cursor: default;
          appearance: none;
          -webkit-appearance: none;
          -moz-appearance: none;
          border: 2px solid white;
          border-radius: 3px;
          background-color: transparent;
          position: relative;
          margin: 0;
          padding: 0;
          pointer-events: none;
          
          &:checked {
            background-color: transparent;
            
            &::after {
              content: "✕";
              position: absolute;
              top: 45%;
              left: 55%;
              transform: translate(-50%, -50%);
              color: white;
              font-size: 14px;
              font-weight: bold;
              line-height: 1;
            }
          }
          
          &:disabled {
            opacity: 1;
            cursor: default;
          }
        }
      }
    }

    /* Override padding for text fields to achieve 20px height */
    .text-field-container.vdr-container {
      padding: 2px !important;
      min-width: 80px !important;
      max-width: 350px !important;
    }

    /* Override padding for checkbox fields to achieve 25px height */
    .checkbox-field-container.vdr-container {
      padding: 0px !important;
      min-width: 28px !important;
      max-width: 28px !important;
      min-height: 28px !important;
      max-height: 28px !important;
      box-sizing: border-box !important;
      overflow: visible !important;
      z-index: 999 !important;
    }

    /* Hide vertical resize handles for text fields */
    .text-field-container .vdr-handle.vdr-handle-t,
    .text-field-container .vdr-handle.vdr-handle-b {
      display: none !important;
    }

    /* Hide resize handles for checkbox fields since they should be fixed size */
    .checkbox-field-container .vdr-handle {
      display: none !important;
    }

    .signature-field {
      span {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    
    /* Styles for past signed attributes */
    .past-attribute {
      pointer-events: none; /* Prevent interaction with past signed attributes */
    }

    .bottom-right-field {
      display: block;
      position: relative;
    }

    .bottom-right-field span {
      position: absolute;
      bottom: 10px;
      right: 10px;
      margin: 0;
    }

    // div div:last-of-type img{
    //       margin-bottom: 200px;
    // }
  }

  .right-side {
    width: 300px;
    padding-left: 3px ;
    padding-top: 5px;
    display: inline-block;
    vertical-align: top;
    position: sticky;
    top: 50px;
    text-align: right;

         .buttons {
       display: flex;
       flex-direction: column;
       gap: 15px;
       align-items: flex-start;
       //border-bottom: 1px solid gray;
       padding: 2px 0;
       justify-content: center;
      
             // Specific styling for client details button
                .client-details-btn {
           background-color: #009b89 !important;
           color: white !important;
           width: 180px !important; /* Match assignee column width */
           height: 25px !important; /* Match assignee button height */
           max-width: none !important;
           //margin-right: 5px !important;
           &:hover {
             background-color: #008a7c !important;
           }
         }
      
             // Align the client details section with חותם 1 column
       &:nth-of-type(2) {
         align-items: flex-start !important; /* Keep right alignment in RTL */
         
         .assignees-row {
           justify-content: flex-end; /* Align to the right like חותם 1 */
         }
         
         .button__item {
           align-items: flex-start;
           
           h2 {
             width: 180px;
             text-align: center;
             margin-bottom: 5px;
           }
         }
       }
      


         .section-title {
          display: flex;
          width: 100%;
          font-weight: 700;
          text-align: right;
          margin-bottom: -3px;
          align-items: end;
          color: #3a4b5c;
          padding-right: 10px;
        }

      .assignees-row {
        display: flex;
        flex-direction: column;
        gap: 5px;
        align-items: flex-start;
        justify-content: center;
      }

      .button__item {
        display: flex;
        flex-direction: column;
        gap: 5px;
        align-items: flex-start;

        h2 {
          display: flex;
          width: 180px;
          font-weight: 700;
          text-align: center;
          margin-bottom: 5px;
          justify-content: center;
        }

                                   button {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 10px;
            width: 180px;
            height: 25px;
            background-color: #607d8b;
            color: white;
            padding: 7px 15px;
            font-size: 15px;
            border: none;
            cursor: pointer;
            border-radius: 4px;
            transition: background-color 0.2s ease;
            
            &:hover {
              background-color: #546e7b;
            }
          }
         
                                                        .assignee-select {
                margin-top: 0px;
                width: 180px;
                position: relative;

                                                  .buefy-dropdown {
                    width: 100%;
                    height: 25px;
                    
                    
                     .dropdown-trigger {
                     width: 100%;
                     height: 25px;
                     padding: 2px 15px;
                     font-size: 15px;
                     font-weight: normal;
                     font-family: Arial, Helvetica, sans-serif;
                     border-radius: 4px;
                     direction: rtl;
                     text-align: center;
                     border: none;
                     cursor: pointer;
                     display: flex;
                     align-items: center;
                     justify-content: center;
                     position: relative;
                     transition: background-color 0.2s ease;
                     
                     .dropdown-arrow {
                       position: absolute;
                       left: 15px;
                       font-size: 12px;
                     }
                   }
                  
                  .search-container {
                     padding: 8px 10px;
                     border-bottom: 0px solid #e0e0e0;
                     background-color: #29e;
                     outline: none;
                     margin-top: -4px;
                     
                     .search-input {
                       margin-bottom: 0;
                       width: 100%;
                       
                       ::v-deep .control {
                         border-radius: 10px;
                         width: 100%;
                       }
                       
                       ::v-deep .input {
                         width: 100%;
                         font-family: Arial, Helvetica, sans-serif;
                         outline: none;
                         border-color: lightgray;
                         border-style: solid;
                         padding: 5px 12px;
                         border-radius: 6px;
                       }
                     }
                   }
                   
                    .dropdown-content {
                      max-height: 190px;
                      overflow-y: auto;
                      background-color: white;
                      margin-top: -6px;
                      border: 2px solid #29e;
                      border-radius: 4px;
                      
                                             /* Custom scrollbar styling */
                       &::-webkit-scrollbar {
                         width: 6px;
                       }
                       
                       /* Force scrollbar to right side in RTL */
                       direction: ltr;
                       text-align: left;
                       
                       &::-webkit-scrollbar-track {
                         background: rgba(41, 153, 238, 0.1);
                         border-radius: 3px;
                       }
                       
                       &::-webkit-scrollbar-thumb {
                         background: rgba(41, 153, 238, 0.3);
                         border-radius: 3px;
                         
                         &:hover {
                           background: rgba(41, 153, 238, 0.5);
                         }
                       }
                       
                       /* Firefox scrollbar */
                       scrollbar-width: thin;
                       scrollbar-color: rgba(41, 153, 238, 0.3) rgba(41, 153, 238, 0.1);
                    }
                   
                   .group-header {
                     background-color: #e3f2fd;
                     color: #1976d2;
                     font-weight: bold;
                     cursor: default;
                     padding: 8px 12px;
                     margin: 0;
                     border-bottom: 1px solid #bbdefb;
                     font-family: Arial, Helvetica, sans-serif;
                     text-align: center;
                     
                     strong {
                       font-size: 13px;
                       text-transform: uppercase;
                       letter-spacing: 0.5px;
                     }
                   }
                   
                    .group-option {
                      padding: 8px 12px;
                      margin: 0;
                      transition: all 0.2s ease;
                      cursor: pointer;
                      background-color: white;
                      color: #333;
                      font-family: Arial, Helvetica, sans-serif;
                      text-align: right;
                      font-size: 12px;
                      font-weight: 700;
                      
                      &:hover {
                        background-color: #f5f5f5;
                        color: #29e;
                      }
                    }
                   
                   .group-separator {
                     padding: 4px 12px;
                     margin: 0;
                     
                     hr {
                       border: none;
                       height: 0px;
                       background-color: #e0e0e0;
                       margin: 0;
                     }
                   }
                }
               
                
             
                                                                                                                                               /* Custom background colors for each assignee */
                &.assignee-1 .dropdown-trigger {
                  background-color: #29e !important;
                  color: white !important;
                  
                  &:hover {
                    background-color: #28e !important;
                  }
                }
                
                &.assignee-2 .dropdown-trigger {
                   background-color: #607d8b !important;
                   color: white !important;
                   
                   &:hover {
                     background-color: #546e7b !important;
                   }
                 }
                 
                 &.assignee-2 .search-container {
                   background-color: #607d8b;
                   
                   .search-input {
                     ::v-deep .control {
                       border-radius: 8px;
                     }
                   }
                 }
                 
                                                                       &.assignee-2 .dropdown-content {
                     background-color: white;
                     margin-top: -6px;
                     border: 2px solid #607d8b;
                     border-radius: 4px;
                     
                                           /* Custom scrollbar styling */
                      &::-webkit-scrollbar {
                        width: 6px;
                      }
                      
                      /* Force scrollbar to right side in RTL */
                      direction: ltr;
                      text-align: left;
                      
                      &::-webkit-scrollbar-track {
                        background: rgba(96, 125, 139, 0.1);
                        border-radius: 3px;
                      }
                      
                      &::-webkit-scrollbar-thumb {
                        background: rgba(96, 125, 139, 0.3);
                        border-radius: 3px;
                        
                        &:hover {
                          background: rgba(96, 125, 139, 0.5);
                        }
                      }
                      
                      /* Firefox scrollbar */
                      scrollbar-width: thin;
                      scrollbar-color: rgba(96, 125, 139, 0.3) rgba(96, 125, 139, 0.1);
                   }
                 
                                                                       &.assignee-2 .group-option {
                     background-color: white;
                     color: #333;
                     
                     &:hover {
                       background-color: #f5f5f5;
                       color: #828285;
                     }
                   }
                  
                  &.assignee-2 .group-header {
                    background-color: #e7e7e7 !important;
                    color: #607d8b !important;
                    border-bottom-color: #e0e0e0 !important;
                  }
            
                         
          }
                    }
     }

     // Buttons Table Styles
     .buttons-table-header {
       margin: 0;
       padding: 16px 16px 12px 16px;
       font-size: 18px;
       font-weight: 600;
       color: #1f2937;
       border-bottom: 2px solid #f1f3f4;
       background: #fafbfc;
       text-align: right;
     }

     .buttons-table {
       display: flex;
       flex-direction: column;
       align-items: stretch;
       text-align: center !important; 
       gap: 0;
       padding: 0;
       direction: rtl;
       background: #ffffff;
       box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
       overflow: hidden;
       border: 1px solid #e8eaed;
       margin-bottom: 5px;
       border-radius: 0px;
     }

     .buttons-table-grid {
       padding: 0;
       background: #ffffff;
       display: flex;
       flex-direction: column;
       border-radius: 8px;
       overflow: hidden;
     }

     .buttons-table-row {
       display: flex;
       align-items: center;
       min-height: 25px;
       max-height: 25px;
       transition: background-color 0.15s ease;
       border-bottom: 1px solid #f1f3f4;
       
       &:last-child {
         border-bottom: none;
       }
       
       // General hover effect removed to allow assignee-specific colors
       
       // Custom hover colors based on assignee - now handled by clickable-row class
       
       // Clickable row styles with assignee-based hover colors
       &.clickable-row {
         cursor: pointer;
         transition: all 0.2s ease;
         border-left: 3px solid transparent;
         
         // Hover colors based on assignee number (data-assignee attribute)
         &[data-assignee="1"]:hover {
           .buttons-table-name,
           .buttons-table-icon,
           .buttons-table-value {
             background-color: rgba(34, 153, 238, 0.1); // Light blue for assignee 1
           }
         }
         
         &[data-assignee="2"]:hover {
           .buttons-table-name,
           .buttons-table-icon,
           .buttons-table-value {
             background-color: rgba(96, 125, 139, 0.1); // Light gray for assignee 2
           }
         }
         
         &[data-assignee="99"]:hover {
           .buttons-table-name,
           .buttons-table-icon,
           .buttons-table-value {
             background-color: rgba(0, 156, 137, 0.1); // Light teal for assignee 99 (representative)
           }
         }
         
         &[data-assignee="label"]:hover {
           .buttons-table-name,
           .buttons-table-icon,
           .buttons-table-value {
             background-color: rgba(0, 156, 137, 0.1); // Light teal for label field
           }
         }
         
         &[data-assignee="textbox"]:hover {
           .buttons-table-name,
           .buttons-table-icon,
           .buttons-table-value {
             background-color: rgba(0, 156, 137, 0.1); // Light teal for textbox field
           }
         }
         
         &[data-assignee="checkbox"]:hover {
           .buttons-table-name,
           .buttons-table-icon,
           .buttons-table-value {
             background-color: rgba(0, 156, 137, 0.1); // Light teal for checkbox field
           }
         }
         
         &:active {
           background-color: #e9ecef;
           //border-left-color: #0056b3;
           
           .buttons-table-name,
           .buttons-table-icon,
           .buttons-table-value {
             background-color: #e9ecef;
           }
         }
       }
     }

     .buttons-table-name {
       flex: 1;
       padding: 12px 16px;
       font-size: 13px;
       color: #495057;
       min-height: 25px;
       max-height: 25px;
       font-weight: 500;
       border-left: 1px solid #e9ecef;
       background: #fafbfc;
       border-bottom: 1px solid #f2f5f8;
       border-top: 1px solid #f2f5f8;
       border-left: none;
       display: flex;
       align-items: center;
       justify-content: flex-start;
       order: 2;
       box-sizing: border-box;
     }

     .buttons-table-icon {
       flex: 0 0 25px;
       min-width: 40px;
       max-width: 40px;
       min-height: 25px;
       max-height: 25px;
       padding: 12px 8px;
       display: flex;
       font-size: 14px;
       align-items: center;
       justify-content: center;
       background: #fafbfc;
       color: #495057;
       order: 1;
       box-sizing: border-box;
     }

     .buttons-table-value {
       flex: 0 0 40px;
       min-width: 40px;
       max-width: 40px;
       min-height: 25px;
       max-height: 25px;
       padding: 12px 8px;
       display: flex;
       font-size: 14px;
       align-items: center;
       justify-content: center;
       background: #fafbfc;
       order: 3;
       
       .circle-icon {
         width: 12px;
         height: 12px;
         border-radius: 50%;
         display: inline-block;
       }
       
       .circle-icon.assignee-1 {
         background-color: #29e; /* ochre */
       }
       
       .circle-icon.assignee-2 {
         background-color: #607d8b; /* gray */
       }
       
       .circle-icon.assignee-99 {
         background-color: #009c89; /* teal */
       }
       
       .circle-icon.label {
         background-color: #009c89; /* teal */
       }
       
       .circle-icon.textbox {
         background-color: #009c89; /* teal */
       }
       
       .circle-icon.checkbox {
         background-color: #009c89; /* teal */
       }
     }
     
     /* Separator styling for visual separation between groups */
     .buttons-table-separator {
       height: 5px;
       background: linear-gradient(to top, #ffffff, #d1d5db6e, #ffffff);
       border: none;
       margin: 0;
       padding: 0;
     }

     .details {
       display: flex;
       flex-direction: column;
       align-items: stretch;
       text-align: center !important; 
       gap: 0;
       padding: 0;
       direction: rtl;
       background: #ffffff;
       //border-radius: 12px;
       box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
       overflow: visible;
       border: 1px solid #e8eaed;



       .properties-header {
         margin: 0;
         padding: 16px 16px 12px 16px;
         font-size: 18px;
         font-weight: 600;
         color: #1f2937;
         border-bottom: 2px solid #f1f3f4;
         background: #fafbfc;
         text-align: right;
       }

       .properties-grid {
         padding: 0;
         background: #ffffff;
         overflow: visible;
         position: relative;
       }

       .property-row {
         display: flex;
         align-items: center;
         height: 25px;
         transition: background-color 0.15s ease;
         border-bottom: 2px solid #f1f3f4;
         
         &:last-child {
           border-bottom: none;
         }
         
         &:hover {
           background-color: #f8f9fa;
         }
         


                   .property-name {
            flex: 0 0 78px;
            padding: 5px 4px;
            font-size: 12px;
            color: #495057;
            font-weight: 500;
            border-left: 1px solid #e9ecef;
            background: #fafbfc;
            border-bottom: 1px solid #f2f5f8;
            border-top: 1px solid #f2f5f8;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

                   .property-value {
            flex: 1;
            padding: 0;
            display: flex;
            font-size: 12px;
            align-items: center;
            justify-content: center;
            min-width: 0;

           .property-input {
             width: 60px;
             text-align: center;
             border-radius: 6px;
             border: 0px solid #ffffff;
             padding: 4px 8px;
             font-size: 13px;
             background: #ffffff00 !important;
             color: #374151;
             transition: all 0.15s ease;
             
             &:focus {
               outline: none;
               border-color: #3b82f6;
               box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
             }
             
             &:read-only {
               background: #f9fafb;
               color: #6b7280;
               cursor: default;
             }
           }
           
           // Special styling for textbox text input
           .textbox-text-input {
             width: 100% !important;
             //text-align: center;
             color: #009c89 !important; // Teal color
             background: #ffffff !important; // Make input visible with white background
             border: 3px solid #e3fdf5 !important; // Slight gray border
             border-radius: 4px;
             padding: 4px 8px;
             
             &::placeholder {
               color: #00c4b45d !important; // Brighter teal color for placeholder
             }
             
             &:focus {
               border-color: #009c89 !important; // Teal border on focus
               outline: none;
               box-shadow: 0 0 0 2px rgba(0, 156, 137, 0.1); // Subtle teal shadow
             }
           }
           
           // Special styling for checkbox input - custom "x" mark
           .property-checkbox {
             width: 15px !important;
             height: 15px !important;
             cursor: pointer;
             appearance: none;
             -webkit-appearance: none;
             -moz-appearance: none;
             border: 2px solid #009c89;
             border-radius: 3px;
             background-color: white;
             position: relative;
             
             &:checked {
               background-color: #009c89;
               
               &::after {
                 content: "✕";
                 position: absolute;
                 top: 50%;
                 left: 50%;
                 transform: translate(-50%, -50%);
                 color: white;
                 font-size: 14px;
                 font-weight: bold;
                 line-height: 1;
               }
             }
           }

           // Binding dropdown styles - using teal color scheme like other dropdowns
           .buefy-dropdown {
             width: 100% !important;
             height: 25px;
             min-width: 100%;
             position: relative;
             z-index: 999;
             overflow: visible;
             display: block;
             
             .dropdown-trigger {
               width: 100% !important;
               height: 100%;
               padding: 5px 15px;
               font-size: 13px;
               font-weight: normal;
               font-family: Arial, Helvetica, sans-serif;
               border-radius: 0;
               direction: rtl;
               text-align: center;
               border: none;
               cursor: pointer;
               display: flex;
               align-items: center;
               justify-content: center;
               position: relative;
               transition: background-color 0.2s ease;
               background-color: white !important;
               border-left: 2px solid #e3fdf5 !important;
               border-right: 2px solid #e3fdf5 !important;
               color: #009c89 !important;
               box-sizing: border-box;
               flex: 1;
               margin: 0;
               
               &:hover {
                 background-color: #f0f0f0 !important;
               }
               
               .dropdown-arrow {
                 position: absolute;
                 left: 5px;
                 font-size: 12px;
               }
             }
             
             .search-container {
               padding: 8px 10px;
               border-bottom: 0px solid #e0e0e0;
               border-left: 2px solid #e3fdf5;
               border-right: 2px solid #e3fdf5;
               background-color: #ffffff;
               outline: none;
               margin-top: -4px;
               

               
               .search-input {
                 margin-bottom: 0;
                 width: 100%;
                 
                 ::v-deep .control {
                   border-radius: 10px;
                   width: 100%;
                 }
                 
                 ::v-deep .input {
                   width: 100%;
                   font-family: Arial, Helvetica, sans-serif;
                   outline: none;
                   border-color: lightgray;
                   border-style: solid;
                   padding: 5px 12px;
                   border-radius: 6px;
                   color: #009c89;
                   
                   &::placeholder {
                     color: #007769;
                     opacity: 0.7;
                   }
                 }
               }
             }
             
             .dropdown-content {
               max-height: 190px;
               overflow-y: auto;
               background-color: white;
               margin-top: -6px;
               //border: 1px solid #009c89;
               border-top: none;
               border-radius: 4px;
               border-top-left-radius: 0px;
               border-left: 2px solid #e3fdf5;
               border-bottom: 2px solid #e3fdf5;
               
               /* Custom scrollbar styling */
               &::-webkit-scrollbar {
                 width: 6px;
               }
               
               /* Force scrollbar to right side in RTL */
               direction: ltr;
               text-align: left;
               
               &::-webkit-scrollbar-track {
                 background: rgba(0, 156, 137, 0.1);
                 border-radius: 3px;
               }
               
               &::-webkit-scrollbar-thumb {
                 background: rgba(0, 156, 137, 0.3);
                 border-radius: 3px;
                 
                 &:hover {
                   background: rgba(0, 156, 137, 0.5);
                 }
               }
               
               /* Firefox scrollbar */
               scrollbar-width: thin;
               scrollbar-color: rgba(0, 156, 137, 0.3) rgba(0, 156, 137, 0.1);
             }
             
             .group-header {
               background-color: #e3fdf5;
               color: #0a7a5e;
               font-weight: bold;
               cursor: default;
               padding: 8px 12px;
               margin: 0;
               border-bottom: 1px solid #bbdefb;
               font-family: Arial, Helvetica, sans-serif;
               text-align: center;
               position: relative;
               z-index: 1001;
               
               strong {
                 font-size: 13px;
                 text-transform: uppercase;
                 letter-spacing: 0.5px;
               }
             }
             
             .group-option {
               padding: 8px 12px;
               margin: 0;
               transition: all 0.2s ease;
               cursor: pointer;
               background-color: white;
               color: #333;
               font-family: Arial, Helvetica, sans-serif;
               text-align: right;
               font-size: 12px;
               font-weight: 700;
               position: relative;
               z-index: 1002;
               pointer-events: auto;
               
               &:hover {
                 background-color: #f5f5f5;
                 color: #009c89;
               }
             }
             
             .group-separator {
               padding: 4px 12px;
               margin: 0;
               
               hr {
                 border: none;
                 height: 0px;
                 background-color: #e0e0e0;
                 margin: 0;
               }
             }
             
             .no-options-message {
               padding: 12px;
               text-align: center;
               color: #6b7280;
               font-style: italic;
               font-size: 12px;
             }
           }
        }
      }
         }
       }
     }


.ochre {
  background-color: #29e !important;
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: #28e !important;
  }
}

.light-gray {
  background-color: #607d8b !important;
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: #546e7b !important;
  }
}

.light-blue {
  background-color: #0060df !important;
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: #0047b3 !important;
  }
}

.teal {
  background-color: #00796bea !important;
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: #00796d !important;
  }
}

/* Ensure teal background works for text fields */
.text-field-container.teal {
  background-color: #00796bea !important;
  
  &:hover {
    background-color: #00796d !important;
  }
}

.title-ochre {
  color: #29e !important;
}

.title-light-gray {
  color: #607d8b !important;
}

.title-light-blue {
  color: #0060df !important;
}

.title-teal {
  color: #00796b !important;
}

.spinner {
  width: 40px;
  height: 40px;
  position: absolute;
  margin: auto auto;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}

.double-bounce1,
.double-bounce2 {
  width: 100%;
  height: 100%;
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  border-radius: 20px;
  background-color: #2e688c;
  opacity: 0.6;
  position: absolute;
  top: 0;
  left: 0;
  -webkit-animation: bounce 2s infinite ease-in-out;
  animation: bounce 2s infinite ease-in-out;
}

.double-bounce2 {
  -webkit-animation-delay: -1s;
  animation-delay: -1s;
}

@-webkit-keyframes bounce {

  0%,
  100% {
    -webkit-transform: scale(0);
  }

  50% {
    -webkit-transform: scale(1);
  }
}

@keyframes bounce {

  0%,
  100% {
    transform: scale(0);
    -webkit-transform: scale(0);
  }

  50% {
    transform: scale(1);
    -webkit-transform: scale(1);
  }
}


@media screen and (max-width: 1100px) {
  .right-side {
    width: 30% !important;
  }

  .all-imgs-container {
    width: 70% !important;
  }

  .form-template-container .dragable-container,
  .form-template-container .dragable-container .buttons-container {
    width: 100% !important;
  }
}

.loading-indicator {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
  color: #666;
  font-size: 12px;
  font-style: italic;
  
  span {
    margin-right: 5px;
  }
}
</style>